import { types } from '../types'

const initialState = {
    waiting: false,
    success: false,
    error: '',
    isAdmin: false,
    accessList: [],
    selectedUserByAdmin:null,
    role:"",
    userAccess:{}
}

const accessReducer = (state = initialState, { type, isAdmin,list,user,role,userAccess }) => {
    switch (type) {


        case types.PUSH_ACCESS_LIST: {
              
            return {
                ...state,
                isAdmin: isAdmin,
                accessList: list,
                role:role,
                userAccess:userAccess
            }
        }

        case types.EMPTY_ACCESS_LIST: {
            return {
                ...state,
                isAdmin: isAdmin,
                accessList: []
            }
        }

        case types.SELECT_USER_BY_ADMIN: {
             
            return {
                ...state,
                selectedUserByAdmin: user
            }
        }

        case types.EMPTY_SELECTED_USER_BY_ADMIN: {
            return {
                ...state,
                isAdmin: false,
                selectedUserByAdmin: null
            }
        }
        default:
            return state
    }
}

export default accessReducer;